import useSWR from "swr";
import { useCreateStripeAdminAxiosInstance } from "../../../Auth/useCreateStripeAdminAxiosInstance.ts";
import { InstallmentsSettlementSummaryDTO } from "./InstallmentsSettlementDTO.ts";

export function useInstallmentsSettlementSummary(orderId: string) {
  const { createAxiosInstance } = useCreateStripeAdminAxiosInstance();
  const { data, error, isLoading } = useSWR(
    ["stripe", `/admin/orders/${orderId}/installments-settlement/summary`],
    async ([, url]) => {
      const { data } =
        await createAxiosInstance().get<InstallmentsSettlementSummaryDTO>(url);
      return data;
    },
    { revalidateOnFocus: false },
  );

  return { summary: data, error, isLoading };
}
